import { fallbackLng } from "../i18nextInit";
import { availableLanguages } from "../i18nextInit";

export const getTemplateList = (locale) => {
  let verifiedLocale = "en";
  if (availableLanguages.indexOf(locale) > -1) {
    verifiedLocale = locale;
  }

  let response = {
    data: [
      {
        key: "Distinct",
        templatename: "Distinct",
        imagesource: `/app/static/images/thumbs/${verifiedLocale}/webp/cv-distinct.webp`,
        templatecd: "Distinct",
        resetFontFamily: '"Roboto TTF", sans-serif',
        resetFontSize: "1",
        resetHeadingFontSize: "1.45",
      },
      {
        key: "Expressive",
        templatename: "Expressive",
        imagesource: `/app/static/images/thumbs/${verifiedLocale}/webp/cv-expressive.webp`,
        templatecd: "Expressive",
        resetFontFamily: '"Century Gothic", sans-serif',
        resetFontSize: "1",
        resetHeadingFontSize: "1.45",
      },
      {
        key: "Bold",
        templatename: "Bold",
        imagesource: `/app/static/images/thumbs/${verifiedLocale}/webp/cv-bold.webp`,
        templatecd: "Bold",
        resetFontFamily: '"Century Gothic", sans-serif',
        resetFontSize: "1",
        resetHeadingFontSize: "1.45",
      },
      {
        key: "cv4",
        templatename: "Elegant",
        imagesource: `/app/static/images/thumbs/${verifiedLocale}/webp/cv4.webp`,
        templatecd: "Elegant",
        resetFontFamily: '"Merriweather", serif',
        resetFontSize: "1",
        resetHeadingFontSize: "1.3",
      },
      {
        key: "cv13",
        templatename: "Quo",
        imagesource: `/app/static/images/thumbs/${verifiedLocale}/webp/cv13.webp`,
        templatecd: "Quo",
        resetFontFamily: '"Roboto TTF", sans-serif',
        resetFontSize: "1",
        resetHeadingFontSize: "1.75",
      },
      {
        key: "cv5",
        templatename: "Original",
        imagesource: `/app/static/images/thumbs/${verifiedLocale}/webp/cv5.webp`,
        templatecd: "Original",
        resetFontFamily: '"Roboto TTF", sans-serif',
        resetFontSize: "1",
        resetHeadingFontSize: "1.45",
      },
      {
        key: "cv11",
        templatename: "Pure",
        imagesource: `/app/static/images/thumbs/${verifiedLocale}/webp/cv11.webp`,
        templatecd: "Pure",
        resetFontFamily: '"Merriweather", serif',
        resetFontSize: "1",
        resetHeadingFontSize: "1.3",
      },
      {
        key: "cv2",
        templatename: "Executive I",
        imagesource: `/app/static/images/thumbs/${verifiedLocale}/webp/cv2.webp`,
        templatecd: "Executive I",
        resetFontFamily: '"Merriweather", serif',
        resetFontSize: "1",
        resetHeadingFontSize: "1.3",
      },
      {
        key: "cv3",
        templatename: "Collegiate",
        imagesource: `/app/static/images/thumbs/${verifiedLocale}/webp/cv3.webp`,
        templatecd: "Collegiate",
        resetFontFamily: '"Open Sans TTF", sans-serif',
        resetFontSize: "1",
        resetHeadingFontSize: "1.3",
      },
      {
        key: "cv12",
        templatename: "Graphite",
        imagesource: `/app/static/images/thumbs/${verifiedLocale}/webp/cv12.webp`,
        templatecd: "Graphite",
        resetFontFamily: '"Roboto TTF", sans-serif',
        resetFontSize: "1",
        resetHeadingFontSize: "1.25",
      },
      {
        key: "cv9",
        templatename: "Lectus",
        imagesource: `/app/static/images/thumbs/${verifiedLocale}/webp/cv9.webp`,
        templatecd: "Lectus",
        resetFontFamily: '"Roboto TTF", sans-serif',
        resetFontSize: "1",
        resetHeadingFontSize: "1.45",
      },
      {
        key: "cv20",
        templatename: "Neque",
        imagesource: `/app/static/images/thumbs/${verifiedLocale}/webp/cv20.webp`,
        templatecd: "Neque",
        resetFontFamily: '"Merriweather", serif',
        resetFontSize: "1",
        resetHeadingFontSize: "1.3",
      },
      {
        key: "cv6",
        templatename: "Modern",
        imagesource: `/app/static/images/thumbs/${verifiedLocale}/webp/cv6.webp`,
        templatecd: "Modern",
        resetFontFamily: '"Merriweather", serif',
        resetFontSize: "1",
        resetHeadingFontSize: "1.3",
      },
      {
        key: "cv15",
        templatename: "Gravity",
        imagesource: `/app/static/images/thumbs/${verifiedLocale}/webp/cv15.webp`,
        templatecd: "Gravity",
        resetFontFamily: '"Roboto TTF", sans-serif',
        resetFontSize: "1",
        resetHeadingFontSize: "1.45",
      },
      {
        key: "cv19",
        templatename: "Pro",
        imagesource: `/app/static/images/thumbs/${verifiedLocale}/webp/cv19.webp`,
        templatecd: "Pro",
        resetFontFamily: '"Open Sans TTF", sans-serif',
        resetFontSize: "1",
        resetHeadingFontSize: "1.45",
      },
      {
        key: "cv8",
        templatename: "Totam",
        imagesource: `/app/static/images/thumbs/${verifiedLocale}/webp/cv8.webp`,
        templatecd: "Totam",
        resetFontFamily: '"Roboto TTF", sans-serif',
        resetFontSize: "1.15",
        resetHeadingFontSize: "1.4",
      },
      {
        key: "cv14",
        templatename: "Armony",
        imagesource: `/app/static/images/thumbs/${verifiedLocale}/webp/cv14.webp`,
        templatecd: "Armony",
        resetFontFamily: '"Roboto TTF", sans-serif',
        resetFontSize: "1",
        resetHeadingFontSize: "1.75",
      },
      {
        key: "cv10",
        templatename: "Harum",
        imagesource: `/app/static/images/thumbs/${verifiedLocale}/webp/cv10.webp`,
        templatecd: "Harum",
        resetFontFamily: '"Roboto TTF", sans-serif',
        resetFontSize: "1",
        resetHeadingFontSize: "1.45",
      },
      {
        key: "cv1",
        templatename: "Classic",
        imagesource: `/app/static/images/thumbs/${verifiedLocale}/webp/cv1.webp`,
        templatecd: "Classic",
        resetFontFamily: '"Open Sans TTF", sans-serif',
        resetFontSize: "1",
        resetHeadingFontSize: "1.3",
      },
      {
        key: "cv7",
        templatename: "Fugiat",
        imagesource: `/app/static/images/thumbs/${verifiedLocale}/webp/cv7.webp`,
        templatecd: "Fugiat",
        resetFontFamily: '"Roboto TTF", sans-serif',
        resetFontSize: "1",
        resetHeadingFontSize: "1.45",
      },
    ],
  };
  return response;
};
export const getCoverLetterTemplateList = (locale) => {
  let verifiedLocale = "en";
  if (availableLanguages.indexOf(locale) > -1) {
    verifiedLocale = locale;
  }

  let response = {
    data: [
      {
        key: "cl01",
        templatename: "Modern1",
        imagesource: `/app/static/images/cover-letter-thumbs/${verifiedLocale}/cl01.jpg`,
        templatecd: "Modern",
        resetFontFamily: '"Merriweather", serif',
        resetFontSize: "1",
        resetHeadingFontSize: "1.3",
      },
      {
        key: "cl02",
        templatename: "Elegant",
        imagesource: `/app/static/images/cover-letter-thumbs/${verifiedLocale}/cl02.jpg`,
        templatecd: "Elegant",
        resetFontFamily: '"Merriweather", serif',
        resetFontSize: "1",
        resetHeadingFontSize: "1.3",
      },
      {
        key: "cl03",
        templatename: "Professional1",
        imagesource: `/app/static/images/cover-letter-thumbs/${verifiedLocale}/cl03.jpg`,
        templatecd: "Professional",
        resetFontFamily: '"Merriweather", serif',
        resetFontSize: "1",
        resetHeadingFontSize: "1.3",
      },
      {
        key: "cl04",
        templatename: "Classic",
        imagesource: `/app/static/images/cover-letter-thumbs/${verifiedLocale}/cl04.jpg`,
        templatecd: "Classic",
        resetFontFamily: '"Merriweather", serif',
        resetFontSize: "1",
        resetHeadingFontSize: "1.3",
      },
      {
        key: "cl05",
        templatename: "Contemporary",
        imagesource: `/app/static/images/cover-letter-thumbs/${verifiedLocale}/cl05.jpg`,
        templatecd: "Contemporary",
        resetFontFamily: '"Merriweather", serif',
        resetFontSize: "1",
        resetHeadingFontSize: "1.3",
      },
      {
        key: "cl06",
        templatename: "Standard",
        imagesource: `/app/static/images/cover-letter-thumbs/${verifiedLocale}/cl06.jpg`,
        templatecd: "Standard",
        resetFontFamily: '"Merriweather", serif',
        resetFontSize: "1",
        resetHeadingFontSize: "1.3",
      },
      {
        key: "cl07",
        templatename: "Professional2",
        imagesource: `/app/static/images/cover-letter-thumbs/${verifiedLocale}/cl07.jpg`,
        templatecd: "Professional1",
        resetFontFamily: '"Merriweather", serif',
        resetFontSize: "1",
        resetHeadingFontSize: "1.3",
      },
      {
        key: "cl08",
        templatename: "Modern2",
        imagesource: `/app/static/images/cover-letter-thumbs/${verifiedLocale}/cl08.jpg`,
        templatecd: "Modern1",
        resetFontFamily: '"Merriweather", serif',
        resetFontSize: "1",
        resetHeadingFontSize: "1.3",
      },
    ],
  };
  return response;
};
export const getYearList = () => {
  var currentYear = new Date().getFullYear();
  var startYear = currentYear - 60;
  var years = [];
  // years.push({ label: "", value: "empty" });

  for (let i = currentYear; i >= startYear; i--) {
    years.push({ label: i, value: i });
  }
  let response = {
    data: years,
  };
  return response;
};
export const getExpMonthList = () => {
  let response = {
    data: [
      { value: "", label: "Month(MM)" },
      { value: "1", label: "01" },
      { value: "2", label: "02" },
      { value: "3", label: "03" },
      { value: "4", label: "04" },
      { value: "5", label: "05" },
      { value: "6", label: "06" },
      { value: "7", label: "07" },
      { value: "8", label: "08" },
      { value: "9", label: "09" },
      { value: "10", label: "10" },
      { value: "11", label: "11" },
      { value: "12", label: "12" },
    ],
  };
  return response;
};
export const getExpYearList = () => {
  let data = [{ value: "", label: "Year" }];
  const year = new Date().getFullYear();
  Array.from(new Array(10), (v, i) => data.push({ value: year + i, label: year + i }));
  let response = {
    data,
    // data: [
    //   { value: "", label: "Year" },
    //   { value: "2022", label: "2022" },
    //   { value: "2023", label: "2023" },
    //   { value: "2024", label: "2024" },
    //   { value: "2025", label: "2025" },
    //   { value: "2026", label: "2026" },
    //   { value: "2027", label: "2027" },
    //   { value: "2028", label: "2028" },
    //   { value: "2029", label: "2029" },
    //   { value: "2030", label: "2030" },
    //   { value: "2031", label: "2031" },
    //   { value: "2032", label: "2032" },
    // ],
  };
  return response;
};
export const getFontFamilyList = (t) => {
  let response = {
    data: [
      { value: "", label: t("review.select_font") },
      { value: "Arial", label: "Arial" },
      { value: '"Bodoni MT"', label: "Bodoni MT" },
      { value: '"Century Gothic"', label: "Century Gothic" },
      { value: '"Courier New"', label: "Courier New" },
      { value: "Georgia", label: "Georgia" },
      { value: '"Merriweather", serif', label: "Merriweather, serif" },
      { value: '"Open Sans TTF", sans-serif', label: "Open Sans" },
      { value: '"Palatino Linotype"', label: "Palatino Linotype" },
      { value: "PT Serif", label: "PT Serif" },
      { value: '"Roboto TTF", sans-serif', label: "Roboto" },
      { value: "Tahoma", label: "Tahoma" },
      { value: '"Times New Roman"', label: "Times New Roman" },
      { value: '"Trebuchet MS"', label: "Trebuchet MS" },
      { value: "Verdana", label: "Verdana" },
    ],
  };
  return response;
};
export const getTumbnailImages = () => {
  let response = {
    data: [
      {
        key: "Distinct",
        value: "/app/static/images/thumbs/en/cv-distinct.jpg",
        label: "Distinct",
        category: "tripple",
        position: "left",
        personal_info: true,
        defaultFontFamily: "",
        defaultFontSize: "",
        defaultHeadingFontSize: "",
      },
      {
        key: "Expressive",
        value: "/app/static/images/thumbs/en/cv-expressive.jpg",
        label: "Expressive",
        category: "tripple",
        position: "left",
        personal_info: true,
        defaultFontFamily: "",
        defaultFontSize: "",
        defaultHeadingFontSize: "",
      },
      {
        key: "Bold",
        value: "/app/static/images/thumbs/en/cv-bold.jpg",
        label: "Bold",
        category: "tripple",
        position: "left",
        personal_info: true,
        defaultFontFamily: "",
        defaultFontSize: "",
        defaultHeadingFontSize: "",
      },
      {
        key: "cv15",
        value: "/app/static/images/thumbs/en/cv15.jpg",
        label: "Gravity",
        category: "tripple",
        position: "left",
        personal_info: false,
        defaultFontFamily: "",
        defaultFontSize: "",
        defaultHeadingFontSize: "",
      },
      {
        key: "cv5",
        value: "/app/static/images/thumbs/en/cv5.jpg",
        label: "Original",
        category: "tripple",
        position: "left",
        personal_info: false,
        defaultFontFamily: "",
        defaultFontSize: "",
        defaultHeadingFontSize: "",
      },
      {
        key: "cv4",
        value: "/app/static/images/thumbs/en/cv4.jpg",
        label: "Elegant",
        category: "single",
        position: "left",
        personal_info: false,
        defaultFontFamily: '"Roboto TTF", sans-serif',
        defaultFontSize: "",
        defaultHeadingFontSize: "",
      },
      {
        key: "cv13",
        value: "/app/static/images/thumbs/en/cv13.jpg",
        label: "Quo",
        category: "single",
        position: "left",
        personal_info: false,
        defaultFontFamily: "",
        defaultFontSize: "",
        defaultHeadingFontSize: "",
      },
      {
        key: "cv8",
        value: "/app/static/images/thumbs/en/cv8.jpg",
        label: "Totam",
        category: "double",
        position: "left",
        personal_info: false,
        defaultFontFamily: "",
        defaultFontSize: "",
        defaultHeadingFontSize: "",
      },
      {
        key: "cv1",
        value: "/app/static/images/thumbs/en/cv1.jpg",
        label: "Classic",
        category: "single",
        position: "left",
        personal_info: false,
        defaultFontFamily: "",
        defaultFontSize: "",
        defaultHeadingFontSize: "",
      },
      {
        key: "cv7",
        value: "/app/static/images/thumbs/en/cv7.jpg",
        label: "Fugiat",
        category: "tripple",
        position: "left",
        personal_info: true,
        defaultFontFamily: "",
        defaultFontSize: "",
        defaultHeadingFontSize: "",
      },
      {
        key: "cv20",
        value: "/app/static/images/thumbs/en/cv20.jpg",
        label: "Neque",
        category: "single",
        position: "left",
        personal_info: false,
        defaultFontFamily: "",
        defaultFontSize: "",
        defaultHeadingFontSize: "",
      },
      {
        key: "cv14",
        value: "/app/static/images/thumbs/en/cv14.jpg",
        label: "Armony",
        category: "single",
        position: "left",
        personal_info: false,
        defaultFontFamily: "",
        defaultFontSize: "",
        defaultHeadingFontSize: "",
      },
      {
        key: "cv3",
        value: "/app/static/images/thumbs/en/cv3.jpg",
        label: "Collegiate",
        category: "single",
        position: "left",
        personal_info: false,
        defaultFontFamily: "",
        defaultFontSize: "",
        defaultHeadingFontSize: "",
      },
      {
        key: "cv6",
        value: "/app/static/images/thumbs/en/cv6.jpg",
        label: "Modern",
        category: "single",
        position: "left",
        personal_info: false,
        defaultFontFamily: "",
        defaultFontSize: "",
        defaultHeadingFontSize: "",
      },
      {
        key: "cv2",
        value: "/app/static/images/thumbs/en/cv2.jpg",
        label: "Executive I",
        category: "single",
        position: "left",
        personal_info: false,
        defaultFontFamily: "",
        defaultFontSize: "",
        defaultHeadingFontSize: "",
      },
      {
        key: "cv11",
        value: "/app/static/images/thumbs/en/cv11.jpg",
        label: "Pure",
        category: "single",
        position: "left",
        personal_info: false,
        defaultFontFamily: "",
        defaultFontSize: "",
        defaultHeadingFontSize: "",
      },
      {
        key: "cv10",
        value: "/app/static/images/thumbs/en/cv10.jpg",
        label: "Harum",
        category: "tripple",
        position: "left",
        personal_info: false,
        defaultFontFamily: "",
        defaultFontSize: "",
        defaultHeadingFontSize: "",
      },
      {
        key: "cv12",
        value: "/app/static/images/thumbs/en/cv12.jpg",
        label: "Graphite",
        category: "double",
        position: "left",
        personal_info: false,
        defaultFontFamily: "",
        defaultFontSize: "",
        defaultHeadingFontSize: "",
      },
      {
        key: "cv9",
        value: "/app/static/images/thumbs/en/cv9.jpg",
        label: "Lectus",
        category: "tripple",
        position: "left",
        personal_info: false,
        defaultFontFamily: "",
        defaultFontSize: "",
        defaultHeadingFontSize: "",
      },
      {
        key: "cv19",
        value: "/app/static/images/thumbs/en/cv19.jpg",
        label: "Pro",
        category: "single",
        position: "left",
        personal_info: false,
        defaultFontFamily: "",
        defaultFontSize: "",
        defaultHeadingFontSize: "",
      },
    ],
  };
  return response;
};
const InputPlaceholder = [{ value: "e.g. Spanish" }, { value: "e.g. German" }, { value: "e.g. French" }];
export const getLanguageList = () => {
  let response = {
    data: [
      { placeholder: "e.g Spanish" },
      { placeholder: "German" },
      { placeholder: "French" },
      { placeholder: "Swedish" },
      { placeholder: "Arabic" },
      { placeholder: "Hindi" },
      { placeholder: "Chinese" },
      { placeholder: "Chinese" },
      { placeholder: "Chinese" },
      { placeholder: "Chinese" },
    ],
  };
  return response;
};
export const getSkillList = (t) => {
  let response = {
    data: [
      { placeholder: t("skill.exp_level_1") },
      { placeholder: t("skill.exp_level_2") },
      { placeholder: t("skill.exp_level_3") },
      { placeholder: t("skill.exp_level_4") },
      { placeholder: t("skill.exp_level_5") },
      { placeholder: t("skill.exp_level_6") },
      { placeholder: t("skill.exp_level_7") },
      { placeholder: t("skill.exp_level_8") },
      { placeholder: t("skill.exp_level_9") },
      { placeholder: t("skill.exp_level_10") },
    ],
  };
  return response;
};
export const getListOfStates = (t) => {
  let response = {
    data: [
      { value: "", label: "Select State" },
      { value: "AL", label: "Alabama" },
      { value: "AK", label: "Alaska" },
      { value: "AS", label: "American Samoa" },
      { value: "AZ", label: "Arizona" },
      { value: "AR", label: "Arkansas" },
      { value: "CA", label: "California" },
      { value: "CO", label: "Colorado" },
      { value: "CT", label: "Connecticut" },
      { value: "DE", label: "Delaware" },
      { value: "DC", label: "District of Columbia" },
      { value: "FL", label: "Florida" },
      { value: "GA", label: "Georgia" },
      { value: "GU", label: "Guam" },
      { value: "HI", label: "Hawaii" },
      { value: "ID", label: "Idaho" },
      { value: "IL", label: "Illinois" },
      { value: "IN", label: "Indiana" },
      { value: "IA", label: "Iowa" },
      { value: "KS", label: "Kansas" },
      { value: "KY", label: "Kentucky" },
      { value: "LA", label: "Louisiana" },
      { value: "ME", label: "Maine" },
      { value: "MD", label: "Maryland" },
      { value: "MA", label: "Massachusetts" },
      { value: "MI", label: "Michigan" },
      { value: "MN", label: "Minnesota" },
      { value: "MS", label: "Mississippi" },
      { value: "MO", label: "Missouri" },
      { value: "MT", label: "Montana" },
      { value: "NE", label: "Nebraska" },
      { value: "NV", label: "Nevada" },
      { value: "NH", label: "New Hampshire" },
      { value: "NJ", label: "New Jersey" },
      { value: "NM", label: "New Mexico" },
      { value: "NY", label: "New York" },
      { value: "NC", label: "North Carolina" },
      { value: "ND", label: "North Dakota" },
      { value: "OH", label: "Ohio" },
      { value: "OK", label: "Oklahoma" },
      { value: "OR", label: "Oregon" },
      { value: "PA", label: "Pennsylvania" },
      { value: "PR", label: "Puerto Rico" },
      { value: "RI", label: "Rhode Island" },
      { value: "SC", label: "South Carolina" },
      { value: "SD", label: "South Dakota" },
      { value: "TN", label: "Tennessee" },
      { value: "TX", label: "Texas" },
      { value: "UT", label: "Utah" },
      { value: "VT", label: "Vermont" },
      { value: "VA", label: "Virginia" },
      { value: "VI", label: "Virgin Islands" },
      { value: "WA", label: "Washington" },
      { value: "WV", label: "West Virginia" },
      { value: "WI", label: "Wisconsin" },
      { value: "WY", label: "Wyoming" },
    ],
  };
  return response;
};
export const getCoverLetterSkills = (t) => {
  let response = {
    data: [
      { id: 0, skillTitle: t("cover_letter_skills.Communication") },
      { id: 1, skillTitle: t("cover_letter_skills.Customer service") },
      { id: 2, skillTitle: t("cover_letter_skills.Teamwork") },
      { id: 3, skillTitle: t("cover_letter_skills.Leadership") },
      { id: 4, skillTitle: t("cover_letter_skills.Problem-solving") },
      { id: 5, skillTitle: t("cover_letter_skills.Time management") },
      { id: 6, skillTitle: t("cover_letter_skills.Adaptability") },
      { id: 7, skillTitle: t("cover_letter_skills.Dependability") },
      { id: 8, skillTitle: t("cover_letter_skills.Technological") },
      { id: 9, skillTitle: t("cover_letter_skills.Work ethic") },
      { id: 10, skillTitle: t("cover_letter_skills.Forecasting") },
      { id: 11, skillTitle: t("cover_letter_skills.Data mining") },
      { id: 12, skillTitle: t("cover_letter_skills.Data presentation") },
      { id: 13, skillTitle: t("cover_letter_skills.Resource management") },
      { id: 14, skillTitle: t("cover_letter_skills.Data engineering") },
      { id: 15, skillTitle: t("cover_letter_skills.Database management") },
      {
        id: 16,
        skillTitle: t("cover_letter_skills.Data and metrics interpreting"),
      },
      { id: 17, skillTitle: t("cover_letter_skills.Reporting") },
      { id: 18, skillTitle: t("cover_letter_skills.Diagnostics") },
      { id: 19, skillTitle: t("cover_letter_skills.Creativity") },
      { id: 20, skillTitle: t("cover_letter_skills.Theorizing") },
      { id: 21, skillTitle: t("cover_letter_skills.Visual communication") },
      { id: 22, skillTitle: t("cover_letter_skills.Slideshows") },
      { id: 23, skillTitle: t("cover_letter_skills.Research") },
      { id: 24, skillTitle: t("cover_letter_skills.Data analysis") },
      { id: 25, skillTitle: t("cover_letter_skills.Graphic design") },
    ],
  };
  return response;
};
export const getFonts = () => {
  let response = [
    { id: 0, fontName: "font-dancing" },
    { id: 1, fontName: "font-saint" },
    { id: 2, fontName: "font-dynalight" },
  ];
  return response;
};

export const getColor = () => {
  let response = [
    { id: 0, type: "black", color: "#111111" },
    { id: 1, type: "blue", color: "#044F8A" },
  ];
  return response;
};

export const getJobTitleFaqs = (t) => {
  return {
    data: {
      question: t("faq-job-title.question"),
      answers: [
        {
          id: 1,
          faq: t("faq-job-title.answer-1"),
        },
        {
          id: 2,
          faq: t("faq-job-title.answer-2"),
        },
        {
          id: 3,
          faq: t("faq-job-title.answer-3"),
        },
        {
          id: 4,
          faq: t("faq-job-title.answer-4"),
        },
      ],
    },
  };
};

export const getExperienceFaqs = (t) => {
  return {
    data: {
      question: t("faq-experience.question"),
      answers: [
        {
          id: 1,
          faq: t("faq-experience.answer-1"),
        },
        {
          id: 2,
          faq: t("faq-experience.answer-2"),
        },
        {
          id: 3,
          faq: t("faq-experience.answer-3"),
        },
        {
          id: 4,
          faq: t("faq-experience.answer-4"),
        },
      ],
    },
  };
};

export const getSkillFaqs = (t) => {
  return {
    data: {
      question: t("faq-skills.question"),
      answers: [
        {
          id: 1,
          faq: t("faq-skills.answer-1"),
        },
        {
          id: 2,
          faq: t("faq-skills.answer-2"),
        },
        {
          id: 3,
          faq: t("faq-skills.answer-3"),
        },
        {
          id: 4,
          faq: t("faq-skills.answer-4"),
        },
      ],
    },
  };
};

export const getRecommendFaqs = (t) => {
  return {
    data: {
      question: t("faq-recommend.question"),
      answers: [
        {
          id: 1,
          faq: t("faq-recommend.answer-1"),
        },
        {
          id: 2,
          faq: t("faq-recommend.answer-2"),
        },
        {
          id: 3,
          faq: t("faq-recommend.answer-3"),
        },
        {
          id: 4,
          faq: t("faq-recommend.answer-4"),
        },
      ],
    },
  };
};
export const categoryIcons = {
    ids: (
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="24" viewBox="0 0 19 24" fill="none">
            <path d="M13.5381 5.45023C13.5381 6.5213 13.1126 7.5485 12.3553 8.30585C11.5979 9.06321 10.5707 9.48869 9.49967 9.48869C8.4286 9.48869 7.4014 9.06321 6.64405 8.30585C5.88669 7.5485 5.46121 6.5213 5.46121 5.45023C5.46121 4.37917 5.88669 3.35197 6.64405 2.59461C7.4014 1.83725 8.4286 1.41177 9.49967 1.41177C10.5707 1.41177 11.5979 1.83725 12.3553 2.59461C13.1126 3.35197 13.5381 4.37917 13.5381 5.45023ZM1.42383 20.6542C1.45843 18.5352 2.3245 16.5147 3.83525 15.0284C5.346 13.5421 7.38038 12.7092 9.49967 12.7092C11.619 12.7092 13.6533 13.5421 15.1641 15.0284C16.6748 16.5147 17.5409 18.5352 17.5755 20.6542C15.0419 21.816 12.2869 22.4155 9.49967 22.4118C6.61782 22.4118 3.88244 21.7828 1.42383 20.6542Z" stroke="#5432FB" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    ),
    legal: (
        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="22" viewBox="0 0 23 22" fill="none">
            <path d="M11.5 1.63123V20.2081M11.5 20.2081C9.91477 20.2081 8.39631 20.4935 6.99308 21.0158M11.5 20.2081C13.0852 20.2081 14.6037 20.4935 16.0069 21.0158M18.7692 3.75276C16.3609 3.41473 13.9319 3.2456 11.5 3.24661C9.03277 3.24661 6.60538 3.41892 4.23077 3.75276M18.7692 3.75276C19.8569 3.90676 20.9338 4.09415 22 4.31276M18.7692 3.75276L21.5908 15.3038C21.7222 15.8412 21.4766 16.4109 20.9565 16.5983C20.2548 16.8501 19.5147 16.9784 18.7692 16.9774C18.0237 16.9784 17.2837 16.8501 16.582 16.5983C16.0618 16.4109 15.8163 15.8412 15.9466 15.3038L18.7692 3.75384V3.75276ZM4.23077 3.75276C3.14308 3.90676 2.06615 4.09415 1 4.31276M4.23077 3.75276L7.05231 15.3038C7.18369 15.8412 6.93815 16.4109 6.418 16.5983C5.71631 16.8501 4.97628 16.9784 4.23077 16.9774C3.48526 16.9784 2.74523 16.8501 2.04354 16.5983C1.52338 16.4109 1.27785 15.8412 1.40815 15.3038L4.23077 3.75384V3.75276Z" stroke="#5432FB" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    ),
    financial: (
        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
            <path d="M11.5 4.32353V18.3235M8 15.0359L9.0255 15.8047C10.3917 16.8302 12.6072 16.8302 13.9745 15.8047C15.3418 14.7792 15.3418 13.1179 13.9745 12.0924C13.292 11.579 12.396 11.3235 11.5 11.3235C10.6542 11.3235 9.80833 11.0669 9.16317 10.5547C7.87283 9.5292 7.87283 7.86787 9.16317 6.84237C10.4535 5.81687 12.5465 5.81687 13.8368 6.84237L14.321 7.22737M22 11.3235C22 12.7024 21.7284 14.0678 21.2007 15.3417C20.6731 16.6156 19.8996 17.7731 18.9246 18.7482C17.9496 19.7232 16.7921 20.4966 15.5182 21.0243C14.2443 21.5519 12.8789 21.8235 11.5 21.8235C10.1211 21.8235 8.75574 21.5519 7.48182 21.0243C6.20791 20.4966 5.05039 19.7232 4.07538 18.7482C3.10036 17.7731 2.32694 16.6156 1.79926 15.3417C1.27159 14.0678 1 12.7024 1 11.3235C1 8.53876 2.10625 5.86804 4.07538 3.89891C6.04451 1.92978 8.71523 0.823532 11.5 0.823532C14.2848 0.823532 16.9555 1.92978 18.9246 3.89891C20.8938 5.86804 22 8.53876 22 11.3235Z" stroke="#5432FB" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    ),
    receipts: (
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="23" viewBox="0 0 19 23" fill="none">
            <path d="M17.5767 13.7466V10.9197C17.5767 9.95574 17.1938 9.03126 16.5121 8.34964C15.8305 7.66802 14.906 7.28509 13.9421 7.28509H12.3267C12.0054 7.28509 11.6972 7.15744 11.47 6.93023C11.2428 6.70303 11.1152 6.39487 11.1152 6.07355V4.45816C11.1152 3.4942 10.7322 2.56972 10.0506 1.8881C9.36898 1.20648 8.4445 0.823547 7.48054 0.823547H5.46131M5.46131 14.5543H13.5382M5.46131 17.7851H9.49978M7.88439 0.823547H2.63439C1.96562 0.823547 1.42285 1.36632 1.42285 2.03509V20.612C1.42285 21.2808 1.96562 21.8235 2.63439 21.8235H16.3652C17.0339 21.8235 17.5767 21.2808 17.5767 20.612V10.5159C17.5767 7.9453 16.5555 5.48002 14.7379 3.66236C12.9202 1.8447 10.455 0.823547 7.88439 0.823547Z" stroke="#5432FB" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    ),
    digital: (
        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="19" viewBox="0 0 23 19" fill="none">
            <path d="M6.65455 14.2713V15.2203C6.6546 15.5917 6.58146 15.9595 6.43932 16.3026C6.29718 16.6458 6.08883 16.9575 5.82616 17.2201L5.24092 17.8054H13.7227L13.1375 17.2201C12.8748 16.9575 12.6665 16.6458 12.5243 16.3026C12.3822 15.9595 12.3091 15.5917 12.3091 15.2203V14.2713M15.5001 14.2713H3.12046C2.55808 14.2713 2.01873 14.0479 1.62107 13.6502C1.2234 13.2525 1 12.7132 1 12.1508V2.96216M1 2.96216C1 2.39978 1.2234 1.86044 1.62107 1.46277C2.01873 1.06511 2.55808 0.841705 3.12046 0.841705H15.8432C16.4056 0.841705 16.9449 1.06511 17.3426 1.46277C17.7403 1.86044 17.9637 2.39978 17.9637 2.96216V6.14285M1 2.96216V9.32354C1 9.88592 1.2234 10.4253 1.62107 10.8229C2.01873 11.2206 2.55808 11.444 3.12046 11.444H15.5001M17.961 6.49626H16.7493C16.428 6.49626 16.1198 6.62392 15.8925 6.85115C15.6653 7.07839 15.5377 7.38659 15.5377 7.70795V16.5937C15.5377 16.915 15.6653 17.2232 15.8925 17.4505C16.1198 17.6777 16.428 17.8054 16.7493 17.8054H20.7883C21.1097 17.8054 21.4179 17.6777 21.6451 17.4505C21.8723 17.2232 22 16.915 22 16.5937V7.70795C22 7.38659 21.8723 7.07839 21.6451 6.85115C21.4179 6.62392 21.1097 6.49626 20.7883 6.49626H19.5766M17.961 6.49626V7.30405H19.5766V6.49626M17.961 6.49626H19.5766M17.961 16.5937H19.5766" stroke="#5432FB" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    ),
    misc: (
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="4" viewBox="0 0 17 4" fill="none">
            <path d="M2.66667 2.32354C2.66667 2.54455 2.57887 2.75651 2.42259 2.91279C2.26631 3.06907 2.05435 3.15687 1.83333 3.15687C1.61232 3.15687 1.40036 3.06907 1.24408 2.91279C1.0878 2.75651 1 2.54455 1 2.32354C1 2.10252 1.0878 1.89056 1.24408 1.73428C1.40036 1.578 1.61232 1.4902 1.83333 1.4902C2.05435 1.4902 2.26631 1.578 2.42259 1.73428C2.57887 1.89056 2.66667 2.10252 2.66667 2.32354ZM9.33333 2.32354C9.33333 2.54455 9.24554 2.75651 9.08926 2.91279C8.93298 3.06907 8.72101 3.15687 8.5 3.15687C8.27899 3.15687 8.06703 3.06907 7.91075 2.91279C7.75446 2.75651 7.66667 2.54455 7.66667 2.32354C7.66667 2.10252 7.75446 1.89056 7.91075 1.73428C8.06703 1.578 8.27899 1.4902 8.5 1.4902C8.72101 1.4902 8.93298 1.578 9.08926 1.73428C9.24554 1.89056 9.33333 2.10252 9.33333 2.32354ZM16 2.32354C16 2.54455 15.9122 2.75651 15.7559 2.91279C15.5996 3.06907 15.3877 3.15687 15.1667 3.15687C14.9457 3.15687 14.7337 3.06907 14.5774 2.91279C14.4211 2.75651 14.3333 2.54455 14.3333 2.32354C14.3333 2.10252 14.4211 1.89056 14.5774 1.73428C14.7337 1.578 14.9457 1.4902 15.1667 1.4902C15.3877 1.4902 15.5996 1.578 15.7559 1.73428C15.9122 1.89056 16 2.10252 16 2.32354Z" fill="#5432FB" stroke="#5432FB" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    ),
};
export const SecurityStarIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
        <path d="M5.00033 0.833984L6.10444 3.09033L8.59196 3.44754L6.82915 5.16615L7.24859 7.64015L5.00033 6.47198L2.75206 7.64015L3.1715 5.16615L1.40869 3.44754L3.89621 3.09033L5.00033 0.833984Z" fill="#8B5CF6"/>
    </svg>
);

export const ThumbnailCogIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="white">
        <path d="M5.00008 1.48792C5.39708 1.48792 5.72758 1.15742 5.72758 0.760417C5.72758 0.363417 5.39708 0.032917 5.00008 0.032917C4.60308 0.032917 4.27258 0.363417 4.27258 0.760417C4.27258 1.15742 4.60308 1.48792 5.00008 1.48792ZM5.00008 3.51292C5.39708 3.51292 5.72758 3.18242 5.72758 2.78542C5.72758 2.38842 5.39708 2.05792 5.00008 2.05792C4.60308 2.05792 4.27258 2.38842 4.27258 2.78542C4.27258 3.18242 4.60308 3.51292 5.00008 3.51292ZM5.00008 5.53792C5.39708 5.53792 5.72758 5.20742 5.72758 4.81042C5.72758 4.41342 5.39708 4.08292 5.00008 4.08292C4.60308 4.08292 4.27258 4.41342 4.27258 4.81042C4.27258 5.20742 4.60308 5.53792 5.00008 5.53792ZM5.00008 7.56292C5.39708 7.56292 5.72758 7.23242 5.72758 6.83542C5.72758 6.43842 5.39708 6.10792 5.00008 6.10792C4.60308 6.10792 4.27258 6.43842 4.27258 6.83542C4.27258 7.23242 4.60308 7.56292 5.00008 7.56292ZM5.00008 9.58792C5.39708 9.58792 5.72758 9.25742 5.72758 8.86042C5.72758 8.46342 5.39708 8.13292 5.00008 8.13292C4.60308 8.13292 4.27258 8.46342 4.27258 8.86042C4.27258 9.25742 4.60308 9.58792 5.00008 9.58792Z" fill="white"/>
    </svg>
);
export const SubsequentAddIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
        {/* Changed stroke to the required blue/gray color. Used #6B7280 (gray-500) for contrast. */}
        <path d="M6.89914 1.55463V12.2689M12.2563 6.91178H1.54199" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);
export const LightBulbIcon = (
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.6746 16.4062H14.3253M12.5 5.46875V6.25M17.4718 7.52816L16.9194 8.08058M19.5312 12.5H18.75M6.25 12.5H5.46875M8.08054 8.08058L7.52811 7.52816M9.73782 15.2622C8.21234 13.7367 8.21234 11.2634 9.73782 9.73788C11.2633 8.2124 13.7366 8.2124 15.2621 9.73788C16.7876 11.2634 16.7876 13.7367 15.2621 15.2622L14.8347 15.6896C14.3402 16.184 14.0625 16.8546 14.0625 17.5539V17.9688C14.0625 18.8317 13.3629 19.5313 12.5 19.5312C11.637 19.5313 10.9375 18.8317 10.9375 17.9688V17.5539C10.9375 16.8546 10.6597 16.184 10.1652 15.6896L9.73782 15.2622Z"
      stroke="#0E77FF"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);